import { render } from "./c-table.vue?vue&type=template&id=126e17ef"
import script from "./c-table.vue?vue&type=script&lang=js"
export * from "./c-table.vue?vue&type=script&lang=js"

import "./c-table.vue?vue&type=style&index=0&id=126e17ef&lang=scss"

import exportComponent from "/builds/secur/secur-v2-cloud/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__